import { useWindowSize } from '@vueuse/core'
import { calculateAutoLayoutColumnsForWidth } from '../../utils/layout/calculateAutoLayoutColumnsForWidth'

type ScreenSizeProperties = {
  browser_window_size: string
  browser_window_width: number
  browser_window_height: number
  column_count: number
}

export const useScreenSizeProperties = (): ScreenSizeProperties => {
  const { width, height } = useWindowSize()
  const browser_window_size = `${width.value}x${height.value}`
  const browser_window_width = width.value
  const browser_window_height = height.value

  const column_count = calculateAutoLayoutColumnsForWidth(width.value)

  return {
    browser_window_size,
    browser_window_width,
    browser_window_height,
    column_count,
  }
}
